import type { ComponentProps } from 'react'
import condolencesIconUrl from '@/assets/condolences-icon.png'
import { cn } from '@/lib/utils'

export default function CondolencesIcon({
  className = '',
  alt = '',
  ...props
}: ComponentProps<'img'>) {
  return (
    <img
      src={condolencesIconUrl}
      alt={alt}
      className={cn('shrink-0 object-contain', className)}
      {...props}
    />
  )
}
